import { pluralize } from 'humanize-plus'

import LoadingDots from 'components/shared/LoadingDots'

import { Modal, Button } from '@driftt/tide-core-legacy'

import './style.styl'

const renderEmailConfirmCopy = (
  hasLimitedContactsMktEmail,
  isCardinalityLoading,
  targetingCardinality
) =>
  hasLimitedContactsMktEmail ?
    <div>
      <span>When you toggle this automated email "on", all contacts in the segments selected for Audience will receive it.</span>
      <div className="playbook-email-send-confirm-cardinality">Currently, that is {isCardinalityLoading ? <LoadingDots /> : targetingCardinality} {pluralize(targetingCardinality || 0, 'person', 'people')}.</div>
      <br/>
      <span>As new contacts are added to the segments, they will be added to the Audience and start receiving this playbooks emails.</span>
    </div> :
    <div>
      <span>When you toggle this email playbook to "On", all contacts in the segments created by the bot will receive the emails.</span>
      <br/>
      <br/>
      <span>As new contacts are added to the segment by the bot, they will be added to the Audience and start receiving the emails as well.</span>
    </div>

const ConditionModal = ({
  onCloseClick,
  targetingCardinality,
  isCardinalityLoading,
  onConfirmClick,
  isOneTimeEmailPlaybook,
  hasLimitedContactsMktEmail
}) => {
  return (
    <Modal
      open={true}
      size="small"
      onClose={onCloseClick}
      className="playbook-email-send-confirm"
    >
    <div className="playbook-email-send-confirm-wrapper">
      <div>
        <h2>Ready to send your email?</h2>
      </div>
        {isOneTimeEmailPlaybook ?
          <div>
            <p>You&#39;re about to send this email to: </p>
            <div className="playbook-email-send-confirm-cardinality">{isCardinalityLoading ? <LoadingDots /> : targetingCardinality} {pluralize(targetingCardinality || 0, 'person', 'people')}.</div>
            <p>This action cannot be undone.</p>
          </div> : renderEmailConfirmCopy(hasLimitedContactsMktEmail, isCardinalityLoading, targetingCardinality)
        }
      </div>
    <footer>
      <div className="playbook-email-send-confirm-actions">
        <Button onClick={onConfirmClick}>{isOneTimeEmailPlaybook ? `Send Email` : `Turn on & Send email`}</Button>
        <Button type="tertiary" onClick={onCloseClick}>Cancel</Button>
      </div>
    </footer>
    </Modal>
  )
}

export default ConditionModal



// WEBPACK FOOTER //
// ./src/scripts/components/playbook/components/SendEmailConfirmModal/component.js